<template>
    <div id="loading">
        <div id="loading-center">
            <div id="loading-center-text">拼命加载中...</div>
        </div>
    </div>
</template>

<script>
import LoginApi from "@/api/login.js";

export default {
    mounted () {
        this.init();
    },

    data: function () {
        return {
            loginUserCode: "",
            timestamp: "",
            sign: ""
        };
    },

    methods: {
        init () {
            let userName = this.$route.query.userName;
            let sign = this.$route.query.sign;
            let timestamp = this.$route.query.timestamp;

            if (userName && sign && timestamp) {
                this.loginUserCode = userName;
                this.timestamp = timestamp;
                this.sign = sign;
                this.onSubmit();
            } else {
                window.location.href = 'http://baoxiu.hhu.edu.cn/api/nsc/cas/pc';
            }
        },

        onSubmit () {
            LoginApi.getClass()
                .login(
                    this.loginUserCode,
                    'password',
                    this.$constant.CATALOG,
                    this.$constant.REQUEST_TYPE,
                    null,
                    'authCode',
                    this.sign,
                    this.timestamp
                ).then((resp) => {
                    if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                        this.$constant.SET_TOKEN(resp.data.data.access_token);
                        LoginApi.getClass()
                            .userInfo()
                            .then((resp) => {
                                if (this.$constant.BIZ_RESPONSE_CODE == resp.data.code) {
                                    let userData = resp.data.data;
                                    let finalMenuVos = [];
                                    if (userData && userData.menuVos && userData.menuVos.length > 0) {
                                        for (let menu of userData.menuVos) {
                                            if (menu.type == 1) {
                                                finalMenuVos.push(menu);
                                            }
                                        }
                                        userData.menuVos = [];
                                        userData.menuVos = finalMenuVos;
                                    }
                                    userData.configInfo = {
                                        sysName: '河海大学报修平台'
                                    };

                                    this.$constant.SET_USER(userData);
                                    this.$router.push({
                                        name: "dashboard",
                                        params: { clearTag: true },
                                    });
                                } else {
                                    this.$message.error(resp.data.msg);
                                    return false;
                                }
                            }).catch((err) => {
                                this.$message.error(err);
                                return false;
                            });
                    } else {
                        this.$message.error(resp.data.msg);
                        return false;
                    }
                }).catch((err) => {
                    this.$message.error(err);
                    return false;
                });
        }
    }
};
</script>